module.exports = __webpack_public_path__ + "static/media/challenge-sticker.b69b49d2.svg";